import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRefOBGyExaminationBreastExaminationDetail = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefOBGyExaminationBreastExamination/GetDetail?` + params, null);

export const GetRefOBGyExaminationBreastExaminationList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefOBGyExaminationBreastExamination/GetList?` + params, null);

export const CreateRefOBGyExaminationBreastExamination = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationBreastExamination/Create`, data);

export const UpdateRefOBGyExaminationBreastExamination = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationBreastExamination/Update`, data);

export const DeleteRefOBGyExaminationBreastExamination = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationBreastExamination/Delete`, data);